import {Col, Flex, Row, Grid, Modal} from "antd";
import {MyText} from "../../../common";
import {WaveContainer} from "../WaveContainer";
// import SectionImg from '../../../../assets/images/pages/Main/section7-1.webp'
import SectionImg from '../../../../assets/images/pages/Main/section7-3.webp'
import QuestionImg from '../../../../assets/images/pages/Main/question-1.webp'
import {useState} from "react";
import {MinusCircleFilled, PlusCircleFilled} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import { useLang } from "../../../../utils/context/lang";

const isMobile = window.innerWidth < 768;

const Collapse = (props: { array: any[] }) => {

  const {array} = props
  const [selectedIndex, setSelectedIndex] = useState<number>(0)
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const handleSelect = (index: number) => {
    setSelectedIndex(prevIndex => (prevIndex === index ? -1 : index));
  };

  return (
    <Flex style={{width: '100%', flexDirection: 'column', justifyContent: 'space-between'}}>
      {array.map((item, index) => (
        <Flex key={index} onClick={() => handleSelect(index)} style={{flex: 1, flexDirection: 'column', cursor: 'pointer', borderBottom: '1px solid #E5E7EA', padding: 24}}>
          <Flex align='center' justify='space-between'>
            <Col span={20}>
            <MyText size={22} color='#130F26' weight={600}>{item.title}</MyText> 

            </Col>
            
            {selectedIndex === index ? <MinusCircleFilled style={{fontSize: 42, color: '#FF9500'}}/> : <PlusCircleFilled style={{fontSize: 42, color: '#00BDF4'}}/>}
          </Flex>

          {selectedIndex === index && (
          <Flex style={{ marginTop: 24, flexDirection: 'column' }}>
            {typeof item.content === 'string' ? (
              item.content.split('\n').map((line, lineIndex) => (
                <MyText
                  key={lineIndex}
                  color="#130F26"
                  size={18}
                  weight={400}
                  lineHeight={screens.xs ? '26px' : '32px'}
                >
                  {line}
                  <br />
                </MyText>
              ))
            ) : (
              <MyText
                color="#130F26"
                size={18}
                weight={400}
                lineHeight={screens.xs ? '26px' : '32px'}
              >
                {item.content}
              </MyText>
            )}
          </Flex>
        )}
        </Flex>
      ))}
    </Flex>
  )
}

export const Section7 = () => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const {handleChangeLang, lang} = useLang()


  const openVideoModal = (url: string) => {
 Modal.confirm({
  icon: null,
  title: '',
  closable: true,
  content: (
    <iframe
      width="100%"
      height={screens.xs ? "300px" : "400px"}
      src={url}
      style={{marginTop: 20}}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  ),
  width: screens.xs ? '100%' : 800,
  okButtonProps: { hidden: true },
  cancelButtonProps: { hidden: true },
  centered: true,
  maskClosable: true,
  onCancel: () => Modal.destroyAll(),
});
};

  const data = [
    {
      title: `${t("aboutPlatform")}`, 
       content: (
      <span>
        {t("platformIntro")}
        <br />
        <br />
       <>
      {" "}
      <a
          onClick={(e) => {
            e.stopPropagation();
            openVideoModal(
              lang === "kk"
                ? "https://www.youtube.com/embed/qaN-IGMGDhk"
                : "https://www.youtube.com/embed/nsS7OcH6in8"
            );
          }}
          style={{ textDecoration: "none", color: "inherit" }}
        >
        {t("promoVideo_first")} <b style={{ color: "#3A6FD8", textDecoration: "underline" }}>{t("promoVideo_label")}</b> {t("promoVideo_rest")}
      </a>
      <br />
      {" "}
      <a
        onClick={(e) => {
          e.stopPropagation(); 
          openVideoModal("https://www.youtube.com/embed/R1bBcxBVLcE");
        }}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {t("videoInstruction_first")} <b style={{ color: "#3A6FD8", textDecoration: "underline" }}>{t("videoInstruction_label")}</b> {t("videoInstruction_rest")}
      </a>
      <br />
      <a
          href={lang === "kk" ? "/nuskaulyk.pdf" : "/instruction.pdf"}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
        {t("textInstruction_first")}{" "}
        <b style={{ color: "#3A6FD8", textDecoration: "underline" }}>{t("textInstruction_label")}</b>{" "}
        {t("textInstruction_rest")}
      </a>
    </>
        <br />
        <br />
        <strong>{t("tip")}:</strong> {t("platformTip")}
      </span>
    ),
    },
    {
      title: `${t("resetPasswordQuestion")}`,
      content: `${t("passwordRecoveryInstructions")}`
    },
    // {
    //   title: `${t("applyConsultationQuestion")}`,
    //   content: `${t("howToApplyForConsultation")}`
    // },
    {
      title: `${t("viewTrainingRecords")}`,
      content: `${t("trainingRecordings")}`
    },
    {
      title: `${t("developmentGamesPurpose")}`,
      content: `${t("educationalGamesDescription")}`
    },
  ]

  return (
    <WaveContainer
      isTop
      topColor='blue'
      isBottom
      bottomColor='orange'
      containerStyle={{
        backgroundColor: '#fff',
      }}>
      <Row justify="center">
        <Col span={20}>
          <Row gutter={[24, 24]} style={screens.xs || isTablet ? { display: 'flex', flexDirection: 'column' } : {}}>
            <Col span={10} style={screens.xs || isTablet ? { maxWidth: '100%' } : {}}>
              <Row gutter={[32, 82]}>
                <Col span={24} style={{textAlign: screens.xs || isTablet ? 'center' : 'left'}}>
                  <MyText color='#0A033C' size={screens.xs || isTablet ? 32 : 48} weight={800} style={{fontFamily: 'Nunito'}}>
                    {t("faq")}
                  </MyText>
                </Col>
                {!(screens.xs || isTablet) && (
                <Col span={24}>
                  <img src={SectionImg} style={{
                  // position: 'absolute',
                  // top: '-10%',
                  // left: '30%',
                  width: screens.xs ? '40%' : '380px',
                  // transform: 'translateX(-40%) translateY(-25%) scale(0.60)',
                }}/>
                </Col>
                )}
              </Row>
            </Col>

            <Col span={14} style={screens.xs || isTablet ? { maxWidth: '100%' } : {}}>
              <Collapse array={data}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </WaveContainer>

  )
}